import React, { useEffect, useState } from "react";
import { FreeUserLanding, PaidUserLanding } from "components/kelas-live";
import { SubscriptionType } from "services/api/sessions/sessionService.types";

import { useKelasLiveContext } from "stores/kelas-live/kelas-live-context";
// import { CallMeBack } from "components/call-me-back/call-me-back";
import Head from "next/head";
import useVacationPeriod from "hooks/use-vacation-period/use-vacation-period";
import { VacationPeriod } from "components/vacation-period/vacation-period";
import { PaidUserMobile } from "components/kelas-live/paid-user-landing/paid-user-mobile";
import { useMediaQuery } from "hooks/use-media-query/use-media-query";
import router from "next/router";
import { useAuth } from "stores/auth/auth-context";
import useEligibleSetNickName from "hooks/pages/use-eligible-set-nickname/use-eligible-set-nickname";
import { SetNickNameModal } from "components/kelas-live/set-nickname-modal/set-nickname-modal";

const KelasLiveUser = (): JSX.Element | null => {
  const { userSubscription, user } = useKelasLiveContext();
  const {
    user: { isUserLoggedIn, userData }
  } = useAuth();
  const { vacationPeriodContent } = useVacationPeriod();
  const primaryUser = user?.userData.primary_user || null;
  const { subscriptionStatus, fetchSubscriptionStatus } =
    userSubscription || {};

  const subscriptionType =
    userSubscription && userSubscription?.subscriptionStatus?.subscriptionType;
  const isLaptop = useMediaQuery("laptop");

  // NickName modal
  const { isEligibleSetNickName, isLoading: isNickNameLoading } =
    useEligibleSetNickName();
  const [showNickNameModal, setShowNickNameModal] = useState(false);

  useEffect(() => {
    if (isEligibleSetNickName && !isNickNameLoading) {
      setShowNickNameModal(true);
    }
  }, [isEligibleSetNickName, isNickNameLoading]);

  useEffect(() => {
    if (
      isUserLoggedIn &&
      userData?.primary_user &&
      userData?.primary_user?.profile_state === "INCOMPLETE"
    ) {
      router.push({
        pathname: "/user/register/add-location",
        query: router.query
      });
    }
  }, [isUserLoggedIn, userData?.primary_user?.profile_state]);

  useEffect(() => {
    if (primaryUser?.access_token)
      fetchSubscriptionStatus(primaryUser?.access_token);
  }, [primaryUser]);

  if (vacationPeriodContent && subscriptionType === SubscriptionType.PAID) {
    return (
      <>
        <Head>
          <title>Bimbel | CoLearn</title>
        </Head>
        {isLaptop ? (
          <VacationPeriod
            title={vacationPeriodContent?.title || ""}
            description={vacationPeriodContent?.subtitle || ""}
            bgImg={vacationPeriodContent?.bgImg || ""}
          />
        ) : (
          <PaidUserMobile primaryUser={primaryUser} />
        )}
      </>
    );
  }

  if (
    subscriptionStatus &&
    primaryUser &&
    (subscriptionType === SubscriptionType.PAID ||
      subscriptionType === SubscriptionType.PAUSED)
  ) {
    return (
      <>
        <Head>
          <title>Bimbel | CoLearn</title>
        </Head>
        <PaidUserLanding
          primaryUser={primaryUser}
          userSubscriptionStatus={subscriptionStatus}
        />
        {/* {subscriptionType === SubscriptionType.PAUSED && <CallMeBack />} */}
        {showNickNameModal && primaryUser && (
          <SetNickNameModal
            isOpen={showNickNameModal}
            primaryUser={primaryUser}
            onSuccess={() => setShowNickNameModal(false)}
            onSkip={() => setShowNickNameModal(false)}
          />
        )}
      </>
    );
  }

  if (
    (subscriptionType === SubscriptionType.TRIAL ||
      subscriptionType === SubscriptionType.FREE_AFTER_PAID ||
      subscriptionType === SubscriptionType.FREE_AFTER_TRIAL) &&
    primaryUser &&
    subscriptionStatus
  ) {
    return (
      <>
        <Head>
          <title>Bimbel | CoLearn</title>
        </Head>
        <FreeUserLanding
          userSubscriptionStatus={subscriptionStatus}
          primaryUser={primaryUser}
        />
        {/* <CallMeBack /> */}
      </>
    );
  }
  return null;
};

export default KelasLiveUser;

KelasLiveUser.requireAuth = true;
